module.exports = __webpack_public_path__ + "media/images/icon_pencil-8b738da15146bebb99d3614e96344b38.png";